import { NumericFormat } from 'react-number-format';

export type FormatNumberInputProps = {
  onChange: (event: { target: { value: string } }) => void;
  value: number | string | null;
  readOnly: boolean;
  useThousandSeparator?: boolean;
  allowNegative?: boolean;
  max?: number;
};

const FormatNumberInput = ({
  onChange,
  value,
  readOnly,
  useThousandSeparator = true,
  allowNegative = true,
  max,
  ...props
}: FormatNumberInputProps) => {
  return (
    <NumericFormat
      thousandSeparator={useThousandSeparator ? ',' : undefined}
      allowNegative={allowNegative}
      decimalScale={2}
      fixedDecimalScale={true}
      value={value}
      isAllowed={(values) => {
        const { floatValue } = values;
        if (floatValue === undefined) return true;
        if (max !== undefined) {
          return floatValue <= max;
        }
        return true;
      }}
      onValueChange={(values) => {
        if (!readOnly) {
          onChange({
            target: {
              value: values.floatValue?.toString() || '',
            },
          });
        }
      }}
      readOnly={readOnly}
      {...props}
    />
  );
};

export default FormatNumberInput;
